import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { fetchEasymsDobovoCategories, fetchEasymsDobovoRates } from '../../../../../../api/dobovoApi/dobovoEasyms'
import {
    selectEasymsCategoriesKV,
    selectEasymsRatesKV
} from '../../../../../../selectors/dobovoSelectors/dobovoEasymsSelector'
import { selectEasymsOrganizationsKV } from '../../../../../../selectors/easymsOrganizationSelector'

const styles = theme => ({
    textField: {
        marginBottom: theme.spacing.unit
    }
})

class ApartmentEditDialog extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        onUpdate: PropTypes.func.isRequired,
        easymsCategoriesKV: PropTypes.array.isRequired,
        onClose: PropTypes.func.isRequired,
        onOpen: PropTypes.func.isRequired,
        fetchEasymsDobovoCategories: PropTypes.func,
        fetchEasymsDobovoRates: PropTypes.func
    }

    state = {
        ourOrganizationId: this.props.item.ourOrganizationId || '',
        rateId: this.props.item.rateId || '',
        ourCategoryId: this.props.item.ourCategoryId || ''
    }

    componentDidMount() {
        this.props.fetchEasymsDobovoRates(this.props.item.ourOrganizationId)
        this.props.fetchEasymsDobovoCategories(this.props.item.ourOrganizationId)
    }

    handleClose = () => {
        this.props.onClose()
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleOrganizationSelect = event => {
        const { value } = event.target

        this.setState(({ ourOrganizationId }) => {
            if (ourOrganizationId === value) {
                return { ourOrganizationId: value }
            } else {
                return { ourOrganizationId: value, rateId: '', ourCategoryId: '' }
            }
        })

        this.props.fetchEasymsDobovoRates(value)
        this.props.fetchEasymsDobovoCategories(value)
    }

    handleSave = () => {
        const { item, onUpdate } = this.props
        const { ourOrganizationId, rateId, ourCategoryId } = this.state

        onUpdate({ ...item, ourOrganizationId, rateId, ourCategoryId })
        this.handleClose()
    }

    render() {
        const { open, item, easymsOrganizationsKV, easymsCategoriesKV, easymsRatesKV, classes } = this.props
        const { ourOrganizationId, ourCategoryId, rateId } = this.state

        const isDisabledSaveButton = !(ourOrganizationId && ourCategoryId && rateId)

        return (
            <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    Редактирование апартаментов (ID: {item.remoteApartmentsId})
                </DialogTitle>
                <DialogContent>
                    <TextField
                        className={classes.textField}
                        fullWidth
                        select
                        label="Организация EasyMS"
                        value={ourOrganizationId}
                        onChange={this.handleOrganizationSelect}
                    >
                        {easymsOrganizationsKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        className={classes.textField}
                        disabled={!ourOrganizationId}
                        fullWidth
                        select
                        label="Тариф EasyMS"
                        value={rateId}
                        onChange={this.handleSelect('rateId')}
                    >
                        {easymsRatesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        className={classes.textField}
                        disabled={!ourOrganizationId}
                        fullWidth
                        select
                        label="Категория EasyMS"
                        value={ourCategoryId}
                        onChange={this.handleSelect('ourCategoryId')}
                    >
                        {easymsCategoriesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Отмена
                    </Button>
                    <Button disabled={isDisabledSaveButton} onClick={this.handleSave} color="primary">
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default connect(
    state => ({
        easymsOrganizationsKV: selectEasymsOrganizationsKV(state),
        easymsRatesKV: selectEasymsRatesKV(state),
        easymsCategoriesKV: selectEasymsCategoriesKV(state)
    }),
    { fetchEasymsDobovoCategories, fetchEasymsDobovoRates }
)(withStyles(styles)(ApartmentEditDialog))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/ApartmentsTab/ApartmentsTable/ApartmentEditDialog.js